import { takeLatest } from 'redux-saga/effects';
import { CAMERA_MODULE } from '../../../configs/moduleNames';

import loadCamerasList from './loadCamerasList';
import loadCamerasStatusesList from './loadCamerasStatusesList';

import { LOAD_CAMERAS_LIST, LOAD_CAMERAS_STATUSES_LIST } from '../actions';

export default function* watchSystem() {
  yield takeLatest(CAMERA_MODULE + LOAD_CAMERAS_LIST, loadCamerasList);
  yield takeLatest(CAMERA_MODULE + LOAD_CAMERAS_STATUSES_LIST, loadCamerasStatusesList);
}
